

function checkForItemstoRemove(items) {
  // look for any products with a _parent false but no parent item with that timestamp
  var i = items.length;
  var k, foundParent;
  while (i--) {
    if(typeof items[i].properties !== "undefined") {
      if(typeof items[i].properties._parent !== "undefined") {
        if(items[i].properties._parent == 'false') {
          // look for a parent with this timestamp:
          k = items.length;
          foundParent = false;
          while (k--) {
            // don't check itself:
            if(k != i) {
              if(typeof items[k].properties !== "undefined") {
                if(typeof items[k].properties._timestamp !== "undefined") {
                  if(items[k].properties._parent == 'true') {
                    if(typeof items[k].properties._timestamp !== "undefined") {
                      if(items[k].properties._timestamp == items[i].properties._timestamp) {
                        foundParent = true;
                      }
                    }
                  }
                }
              }
            }
          }
          if(!foundParent) {
            removeCartItem(items[i].key);
          }
        }
      }
    }
  }
}

function filterOutGiftWrapProducts(items) {
  // remove gift wrap etc from "you may also like":
  var i = items.length;
  while (i--) {
    if((items[i].tags.includes("Greetings Card")) || (items[i].tags.includes("Gift Wrapping"))) {
      items.splice(i, 1);
    }
  }
  return items;
}

function removeCartItem(itemKey) {
  var formData = {
    'id': itemKey.toString(),
    'quantity': 0
  }
  fetch(window.Shopify.routes.root + "cart/change.js", {
     method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  }).then((response) => response.json()).then((data2) => {
    if (data2.status === 422) {
      this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
    }
    location.reload();
    
  }).catch((error2) => {
    console.error("Error:", error2);
  });
}

function modifyCartItems(items) {
  var originalItems = JSON.parse(JSON.stringify(items));
  var i = items.length;
  var j, k, requiredTimestamp, propertyName, propertySplit, thisItemPriceIncrease;
  var indexesToRemove = [];
  while (i--) {
    items[i].hasGiftWrap = false;
    thisItemPriceIncrease = 0;
    // look for gift wrap items to visually skip
    if(typeof items[i].properties !== "undefined") {
      if(typeof items[i].properties._parent !== "undefined") {
        if(items[i].properties._parent == "false") {
          indexesToRemove.push(i);
        } else {
          if(typeof items[i].properties._timestamp !== "undefined") {
            // find any related children:
            requiredTimestamp = items[i].properties._timestamp;
            k = items.length;
            while (k--) {
              // don't check itself:
              if(k != i) {
                if(typeof items[k].properties !== "undefined") {
                  if(typeof items[k].properties._timestamp !== "undefined") {
                    if(items[k].properties._timestamp == requiredTimestamp) {
                      thisItemPriceIncrease += items[k].line_price;
                      propertyName = "";
                      if(items[k].title.indexOf(" - ") !== -1) {
                        propertySplit = items[k].title.split(" - ");
                        items[i].properties[propertySplit[0]] = propertySplit[1];
                        // needs better logic? ####
                        items[i].giftWrapImage = items[k].featured_image.url;
                      } else {
                        items[i].properties['Gift Card'] = items[k].title;
                        // needs better logic? ####
                        items[i].giftCardImage = items[k].featured_image.url;
                      }
                      // see if this item has a message:
                      if(typeof items[k].properties["Gift Message"] !== "undefined") {
                        items[i].properties['Gift Message'] = items[k].properties["Gift Message"];
                      }                      
                      items[i].hasGiftWrap = true;
                    }
                  }
                }
              }
            }
            // increase price
            items[i].line_price += thisItemPriceIncrease;
            items[i].original_line_price += thisItemPriceIncrease;
          } 
        }
      }
    }
  }
  // make sure the indexesToRemove are sorted descending (they should be, but just in case):
  indexesToRemove.sort().reverse();
  for (i=0;i<indexesToRemove.length;i++) {
    items.splice(indexesToRemove[i], 1);
  }
  // use a new loop now we've removed items:
  i = items.length;
  while (i--) {
    if(typeof items[i].properties !== "undefined") {
      // remove any properties with an underscore:
      var propertiesToShow = {};
      for (p in items[i].properties) {
        if(p.charAt(0) !== '_') {
          propertiesToShow[p] = items[i].properties[p];
        }
      }
      items[i].properties = propertiesToShow;
    }
  }
  checkForItemstoRemove(originalItems);
  return items;
}

function modifyCartCount(items) {
  // adjust the cart count to allow for any skipped gift wrap items:
  var quantity = 0;
  var i, shouldBeCounted;
  for(i in items) {
    shouldBeCounted = true;
    if(typeof items[i].properties !== "undefined") {
      if(typeof items[i].properties._parent !== "undefined") {
        if(items[i].properties._parent == "false") {
          shouldBeCounted = false;
        }
      }
    }
    if(shouldBeCounted) {
      quantity += items[i].quantity;
    }
  }
  return quantity;
}


let giftWrapSelections = {};

function addTimeStampToCartItem(itemKey,itemQuantity,variantId) {
  // NB this will remove any existing properties on the item
  var formData = {
    'id': itemKey.toString(),
    'quantity': 1,
    'properties': {
        '_timestamp': giftWrapSelections.timestamp,
        '_parent': "true"
    }
  }
  if(giftWrapSelections.giftMessage != '') {
    formData.properties['Gift Message'] = giftWrapSelections.giftMessage;
  }
  fetch(window.Shopify.routes.root + "cart/change.js", {
     method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  }).then((response) => response.json()).then((data2) => {
    if (data2.status === 422) {
      this.error_title = data2.message, this.error_message = data2.description, this.show_alert = true;
    }
    if(itemQuantity == 1) {
      addChildLineItems();
    } else {
      createNonGiftWrappedDuplicates(itemQuantity,variantId);
    }
    
  }).catch((error2) => {
    console.error("Error:", error2);
  });
}

function createNonGiftWrappedDuplicates(itemQuantity,variantId) {
  // if the customer has 3 of an item in their cart and click gift wrap, it will wrap 1 and then add 2 as a new line item:
  var formData = {items: []}
  formData.items.push({
    'id': variantId,
    'quantity': (itemQuantity-1)
  }); 
  fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  })
  .then(response => {
      addChildLineItems();
      return response.json();
  })
  .catch((error) => {
      console.error('Error:', error);
  });
}

function addChildLineItems() {
  var variants = [];
  if((giftWrapSelections.wrappingVariant != '') && (giftWrapSelections.wrappingVariant != 'null')) {
    variants.push([giftWrapSelections.wrappingVariant, false]);
  }
  if(giftWrapSelections.giftCard != '') {
    variants.push([giftWrapSelections.giftCard, true]);
  }
  if(variants.length > 0) {
    var formData = {items: []}
    for (let i = 0; i < variants.length; i++) {
      formData.items.push({
          'id': variants[i][0],
          'quantity': 1,
          'properties': {
              '_timestamp': giftWrapSelections.timestamp,
              '_parent': "false"
          }
      });   

      // check if it's a card:
      if(variants[i][1]){
        if(giftWrapSelections.giftMessageCard != '') {
          formData.items[(formData.items.length-1)].properties['Gift Message'] = giftWrapSelections.giftMessageCard;
        }
      }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        resetStoredValues();
        location.reload();
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  } else {
    // reload to get the changes to the parent:
    resetStoredValues();
    location.reload();
  }
}

function addGiftWrap(itemKey, lineQuantity, variantId) {
  // store the reference to the line item to add the gift wrap to:
  giftWrapSelections.lineKey = itemKey;
  giftWrapSelections.lineQuantity = lineQuantity;
  giftWrapSelections.variantId = variantId;
  document.body.classList.add('giftWrapActive');
  document.getElementById('giftWrapWrapper').classList.add('active');
}

function closeGiftWrapModal() {
  // reset initial actives:
  var i;
  var giftWrapChoices = document.querySelectorAll('#giftWrapWrapper .giftWrapOption');
  for (i = 0; i < giftWrapChoices.length; i++) {
    if(i == 0) {
      giftWrapChoices[i].classList.add('active');
    } else {
      giftWrapChoices[i].classList.remove('active');
    }
  }
  var greetingCardChoices = document.querySelectorAll('#giftMessageWrapper .greetingCardOption');
  for (i = 0; i < greetingCardChoices.length; i++) {
    if(i == 0) {
      greetingCardChoices[i].classList.add('active');
    } else {
      greetingCardChoices[i].classList.remove('active');
    }
  }
  var giftMessageChoices = document.querySelectorAll('#giftMessageWrapper .giftMessageOption');
  for (i = 0; i < giftMessageChoices.length; i++) {
    if(i == 1) {
      // defaults to the second choice for the card:
      giftMessageChoices[i].classList.add('active');
    } else {
      giftMessageChoices[i].classList.remove('active');
    }
  }

  document.getElementById('giftWrapWrapper').classList.add('active');
  document.getElementById('giftMessageWrapper').classList.remove('active');

  resetStoredValues();
  document.body.classList.remove('giftWrapActive');
}

function giftWrapSelection(e) {
  var i;
  var giftWrapChoices = document.querySelectorAll('#giftWrapWrapper .giftWrapOption');
  for (i = 0; i < giftWrapChoices.length; i++) {
    giftWrapChoices[i].classList.remove('active');
  }
  e.target.closest('.giftWrapOption').classList.add('active');
}

function backtoGiftWrap() {
  document.getElementById('giftWrapWrapper').classList.add('active');
  document.getElementById('giftMessageWrapper').classList.remove('active');
}

function giftWrapSelected() {
  giftWrapSelections.wrappingVariant = document.querySelector('#giftWrapWrapper .giftWrapOption.active').getAttribute('data-variant');
  giftWrapSelections.timestamp = Date.now();
  document.getElementById('giftWrapSelected').innerHTML = document.querySelector('#giftWrapWrapper .giftWrapOption.active').getAttribute('data-title');
  // show the message panel
  document.getElementById('giftWrapWrapper').classList.remove('active');
  document.getElementById('giftMessageWrapper').classList.add('active');
  console.log(document.getElementById('mobileHeader').style.display);
  
  if(window.getComputedStyle(document.getElementById('mobileHeader'), null).display != 'none') {
    // mobile only:
    document.getElementById('giftMessageWrapper').scrollIntoView();
  }
}

function greetingCardSelection(e) {
  // probably should have made a generic add active sibling class function ...
  var i;
  var greetingCardChoices = document.querySelectorAll('#giftMessageWrapper .greetingCardOption');
  for (i = 0; i < greetingCardChoices.length; i++) {
    greetingCardChoices[i].classList.remove('active');
  }
  e.target.closest('.greetingCardOption').classList.add('active');  
}

function giftMessageSelection(e) {
  var i;
  var giftMessageChoices = document.querySelectorAll('#giftMessageWrapper .giftMessageOption');
  for (i = 0; i < giftMessageChoices.length; i++) {
    giftMessageChoices[i].classList.remove('active');
  }
  e.target.closest('.giftMessageOption').classList.add('active');
}

function giftMessageNextStep(e) {
  if(e) {
    e.preventDefault();
  }
  // determine message (if any)
  var activeMessage = document.querySelector('#giftMessageWrapper .giftMessageOption.active .giftWrapMessageContents');
  giftWrapSelections.giftMessage = '';
  giftWrapSelections.giftMessageCard = '';
  if (activeMessage !== null) {
    if(activeMessage.id == "giftWrapMessageContentsCard") {
      giftWrapSelections.giftMessageCard = activeMessage.value;
    } else {
      giftWrapSelections.giftMessage = activeMessage.value;
    }
  }
  // determine card (if any)
  var activeCard = document.querySelector('#giftMessageWrapper .giftMessageOption.active .greetingCardOption.active');
  if (activeCard !== null) {
    giftWrapSelections.giftCard = activeCard.getAttribute('data-variant');
  } else {
    giftWrapSelections.giftCard = '';
  }
  addTimeStampToCartItem(giftWrapSelections.lineKey,giftWrapSelections.lineQuantity,giftWrapSelections.variantId);
}

function resetStoredValues() {
    giftWrapSelections.lineKey = '';
    giftWrapSelections.lineQuantity = 0;
    giftWrapSelections.variantId = '';
    giftWrapSelections.wrappingVariant = '';
    giftWrapSelections.timestamp = '';
    giftWrapSelections.giftMessage = '';
    giftWrapSelections.giftMessageCard = '';
    giftWrapSelections.giftCard = '';
}

function initGiftWrap() {
  resetStoredValues();
  var i;
  var giftWrapChoices = document.querySelectorAll('#giftWrapWrapper .giftWrapOption');
  for (i = 0; i < giftWrapChoices.length; i++) {
    giftWrapChoices[i].onclick = giftWrapSelection;
  }
  var giftMessageChoices = document.querySelectorAll('#giftMessageWrapper .giftMessageOption');
  for (i = 0; i < giftMessageChoices.length; i++) {
    giftMessageChoices[i].onclick = giftMessageSelection;
  }
  var greetingCardChoices = document.querySelectorAll('#giftMessageWrapper .greetingCardOption');
  for (i = 0; i < greetingCardChoices.length; i++) {
    greetingCardChoices[i].onclick = greetingCardSelection;
  }
  document.getElementById('giftMessageNext').onclick = giftMessageNextStep;
  document.getElementById('giftWrapNext').onclick = giftWrapSelected;
  document.getElementById('giftWrapBack').onclick = backtoGiftWrap;
  document.getElementById('giftWrapModalClose').onclick = closeGiftWrapModal;
}

if(document.getElementById('giftWrapWrapper')) {
  initGiftWrap();
}

jQuery(document).ready(function() {
  jQuery("#read-more").click(function(e){
    e.preventDefault();
    jQuery("#banner-description").toggleClass("expanded")
  });
});